var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicCelebrateConfetti = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 876,
    viewBox: "0 0 1300 876",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hide-if-prefers-reduced-motion",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 451,
    width: 35.1,
    height: 13.73,
    transform: "rotate(-46 806 451)",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall-left animation-delay-200 opacity-0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 272,
    width: 40.1,
    height: 11.73,
    transform: "rotate(-107 620 272)",
    fill: "#FF7272",
    fillOpacity: 0.75,
    className: "animate-confetti-fall-right animation-delay-800 opacity-0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 599,
    width: 41.1,
    height: 12.73,
    transform: "rotate(-33 175 599)",
    fill: "#FF7272",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1500 opacity-0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1191,
    y: 231,
    width: 26.1,
    height: 13.73,
    transform: "rotate(24 1191 231)",
    fill: "#DB2FBD",
    fillOpacity: 0.85,
    className: "animate-confetti-fall-left animation-delay-300 opacity-0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 190,
    width: 46.1,
    height: 13.73,
    transform: "rotate(33 320 190)",
    fill: "#FF7272",
    fillOpacity: 0.85,
    className: "animate-confetti-fall-right animation-delay-1200 opacity-0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1269,
    y: 148,
    width: 20.1,
    height: 16.73,
    transform: "rotate(92 1269 148)",
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall-left animation-delay-600 opacity-0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 505,
    width: 19.1,
    height: 11.73,
    transform: "rotate(-123 426 505)",
    fill: "#DB2FBD",
    fillOpacity: 0.65,
    className: "animate-confetti-fall-right animation-delay-1000 opacity-0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1134,
    y: 760,
    width: 24.1,
    height: 12.73,
    transform: "rotate(-107 1134 760)",
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall-left animation-delay-400 opacity-0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 887,
    y: 307,
    width: 31.1,
    height: 11.73,
    transform: "rotate(-24 887 307)",
    fill: "#B35BF0",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 648,
    width: 24.1,
    height: 15.73,
    transform: "rotate(143 557 648)",
    fill: "#DB2FBD",
    fillOpacity: 0.85,
    className: "animate-confetti-fall-right animation-delay-700 opacity-0"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 418,
    width: 21.1,
    height: 10.73,
    transform: "rotate(121 543 418)",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall-left animation-delay-1000 opacity-0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1243,
    y: 433,
    width: 10.1,
    height: 15.73,
    transform: "rotate(167 1243 433)",
    fill: "#B35BF0",
    className: "animate-confetti-fall-right animation-delay-1400 opacity-0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 388,
    width: 26.1,
    height: 9.73,
    transform: "rotate(28 171 388)",
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1183,
    y: 86,
    width: 9.1,
    height: 11.73,
    transform: "rotate(-10 1183 86)",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-500 opacity-0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 738,
    width: 30.1,
    height: 14.73,
    transform: "rotate(-92 536 738)",
    fill: "#B35BF0",
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 304,
    width: 16.1,
    height: 8.73,
    transform: "rotate(-139 537 304)",
    fill: "#DB2FBD",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1021,
    y: 434,
    width: 47.1,
    height: 12.73,
    transform: "rotate(-27 1021 434)",
    fill: "#B35BF0",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-100 opacity-0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1086,
    y: 375,
    width: 52.1,
    height: 16.73,
    transform: "rotate(-140 1086 375)",
    fill: "#DB2FBD",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 677,
    y: 261,
    width: 44.1,
    height: 17.73,
    transform: "rotate(83 677 261)",
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 608.527,
    y: 332,
    width: 39.1,
    height: 16.73,
    transform: "rotate(39 608.527 332)",
    fill: "#DB2FBD",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 739,
    width: 41.1,
    height: 10.73,
    transform: "rotate(133 109 739)",
    fill: "#FF7272",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 269,
    width: 26.1,
    height: 9.73,
    transform: "rotate(15 292 269)",
    fill: "#FF7272",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1161,
    y: 87,
    width: 46.1,
    height: 14.73,
    transform: "rotate(-36 1161 87)",
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 49.5693,
    width: 43.1,
    height: 12.73,
    transform: "rotate(-81 17 49.5693)",
    fill: "#DB2FBD",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-300 opacity-0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 822,
    y: 873,
    width: 10.1,
    height: 13.73,
    transform: "rotate(-47 822 873)",
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 352,
    width: 11.1,
    height: 9.73,
    transform: "rotate(-8 1217 352)",
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 479,
    width: 47.1,
    height: 14.73,
    transform: "rotate(-114 223 479)",
    fill: "#F00A29",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-400 opacity-0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 466,
    width: 19.1,
    height: 16.73,
    transform: "rotate(-100 73 466)",
    fill: "#F00A29",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-1500 opacity-0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 9,
    width: 35.1,
    height: 15.73,
    transform: "rotate(123 351 9)",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall-left animation-delay-700 opacity-0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 41,
    width: 30.1,
    height: 14.73,
    transform: "rotate(153 830 41)",
    fill: "#FF7272",
    fillOpacity: 0.65,
    className: "animate-confetti-fall-right animation-delay-200 opacity-0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 69,
    width: 32.1,
    height: 16.73,
    transform: "rotate(-175 505 69)",
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall-left animation-delay-1100 opacity-0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 723,
    y: 443,
    width: 19.1,
    height: 14.73,
    transform: "rotate(119 723 443)",
    fill: "#B35BF0",
    fillOpacity: 0.9,
    className: "animate-confetti-fall-right animation-delay-900 opacity-0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 840,
    width: 38.1,
    height: 9.73,
    transform: "rotate(-156 107 840)",
    fill: "#DB2FBD",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1107,
    y: 210,
    width: 21.1,
    height: 12.73,
    transform: "rotate(166 1107 210)",
    fill: "#FF7272",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-500 opacity-0"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 50,
    width: 49.1,
    height: 13.73,
    transform: "rotate(156 156 50)",
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall-left animation-delay-1200 opacity-0"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 541,
    width: 26.1,
    height: 10.73,
    transform: "rotate(-72 256 541)",
    fill: "#DB2FBD",
    className: "animate-confetti-fall-right animation-delay-900 opacity-0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 429.25,
    cy: 209.25,
    r: 6.25,
    fill: "#020202ff",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.25,
    cy: 852.25,
    r: 5.25,
    fill: "#FF7272",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 938.25,
    cy: 846.25,
    r: 9.25,
    fill: "#F00A29",
    fillOpacity: 0.9,
    className: "animate-confetti-fall-left animation-delay-1100 opacity-0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1121.25,
    cy: 24.25,
    r: 6.25,
    fill: "#DB2FBD",
    fillOpacity: 0.6,
    className: "animate-confetti-fall-right animation-delay-800 opacity-0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1266.25,
    cy: 331.25,
    r: 5.25,
    fill: "#FF7272",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-400 opacity-0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.75,
    cy: 672.75,
    r: 4.75,
    fill: "#FF7272",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.25,
    cy: 97.25,
    r: 7.25,
    fill: "#FF7272",
    className: "animate-confetti-fall-left animation-delay-200 opacity-0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1293.75,
    cy: 430.75,
    r: 4.75,
    fill: "#F00A29",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.25,
    cy: 505.25,
    r: 4.25,
    fill: "#DB2FBD",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.75,
    cy: 167.75,
    r: 9.75,
    fill: "#F00A29",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.25,
    cy: 622.25,
    r: 6.25,
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall-right animation-delay-1000 opacity-0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1133.75,
    cy: 669.75,
    r: 6.75,
    fill: "#FF7272",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-500 opacity-0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 946.75,
    cy: 193.75,
    r: 6.75,
    fill: "#F00A29",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 525.25,
    cy: 321.25,
    r: 9.25,
    fill: "#B35BF0",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.75,
    cy: 690.75,
    r: 8.75,
    fill: "#F00A29",
    fillOpacity: 0.9,
    className: "animate-confetti-fall-left animation-delay-300 opacity-0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.75,
    cy: 152.75,
    r: 6.75,
    fill: "#B35BF0",
    fillOpacity: 0.65,
    className: "animate-confetti-fall-right animation-delay-1400 opacity-0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.75,
    cy: 455.75,
    r: 6.75,
    fill: "#FF7272",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1248.75,
    cy: 768.75,
    r: 7.75,
    fill: "#B35BF0",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-100 opacity-0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.25,
    cy: 763.25,
    r: 3.25,
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall-left animation-delay-1200 opacity-0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1163.75,
    cy: 223.75,
    r: 6.75,
    fill: "#FF7272",
    fillOpacity: 0.65,
    className: "animate-confetti-fall-right animation-delay-1500 opacity-0"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1174.75,
    cy: 405.75,
    r: 9.75,
    fill: "#B35BF0",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.75,
    cy: 359.75,
    r: 9.75,
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.75,
    cy: 147.75,
    r: 4.75,
    fill: "#DB2FBD",
    className: "animate-confetti-fall-left animation-delay-400 opacity-0"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1126.75,
    cy: 521.75,
    r: 5.75,
    fill: "#DB2FBD",
    fillOpacity: 0.75,
    className: "animate-confetti-fall-right animation-delay-1300 opacity-0"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 947.75,
    cy: 866.75,
    r: 7.75,
    fill: "#FF7272",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.75,
    cy: 576.75,
    r: 6.75,
    fill: "#B35BF0",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.25,
    cy: 65.25,
    r: 8.25,
    fill: "#B35BF0",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1194.25,
    cy: 406.25,
    r: 4.25,
    fill: "#DB2FBD",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.25,
    cy: 80.25,
    r: 3.25,
    fill: "#FF7272",
    className: "animate-confetti-fall animation-delay-500 opacity-0"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1304.75,
    cy: 668.75,
    r: 9.75,
    fill: "#B35BF0",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.75,
    cy: 306.75,
    r: 4.75,
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.75,
    cy: 23.75,
    r: 5.75,
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.25,
    cy: 318.25,
    r: 7.25,
    fill: "#FF7272",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.75,
    cy: 211.75,
    r: 5.75,
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1306.75,
    cy: 823.75,
    r: 7.75,
    fill: "#B35BF0",
    className: "animate-confetti-fall animation-delay-300 opacity-0"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.75,
    cy: 540.75,
    r: 9.75,
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.333 124.379L354.053 118.914L362.872 128.372L356.603 139.681L343.909 137.214L342.333 124.379Z",
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall-left animation-delay-100 opacity-0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M832.536 668.321L826.751 661.177L833.894 655.392L839.679 662.536L832.536 668.321Z",
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall-right animation-delay-200 opacity-0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M965.909 543.051L958.529 545.029L954.367 538.621L959.176 532.682L966.309 535.421L965.909 543.051Z",
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall-left animation-delay-300 opacity-0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.78 395.035L1192.39 395.527L1189.02 386.747L1196.33 380.828L1204.22 385.95L1201.78 395.035Z",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall-right animation-delay-400 opacity-0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M856.279 28.3814L863.02 23.6614L869.592 28.6137L866.913 36.3944L858.685 36.2508L856.279 28.3814Z",
    fill: "#F00A29",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-500 opacity-0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M983.806 612.782L985.83 602.37L996.242 604.394L994.218 614.806L983.806 612.782Z",
    fill: "#DB2FBD",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.088 87.8089L136.955 80.1688L144.18 77.6811L148.778 83.7836L144.396 90.0429L137.088 87.8089Z",
    fill: "#B35BF0",
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M714.033 726.539L723.975 722.92L730.489 731.257L724.572 740.029L714.402 737.112L714.033 726.539Z",
    fill: "#F00A29",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M917.314 274.233L925.398 276.859L927.165 285.174L920.849 290.861L912.765 288.235L910.998 279.92L917.314 274.233Z",
    fill: "#F00A29",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.41 54.6593L1214.34 61.7303L1204.68 59.1421L1202.09 49.4829L1209.16 42.4118L1218.82 45L1221.41 54.6593Z",
    fill: "#FF7272",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M393.688 498.002L389.374 507.691L379.684 503.377L383.998 493.688L393.688 498.002Z",
    fill: "#B35BF0",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M872.06 437.357L874.996 446.392L868.639 453.452L859.346 451.476L856.411 442.441L862.767 435.382L872.06 437.357Z",
    fill: "#F00A29",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M662.894 268.785L660.187 284.137L648.246 274.117L662.894 268.785Z",
    fill: "#DB2FBD",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M744.608 644L728.215 639.608L732.608 623.215L749 627.608L744.608 644Z",
    fill: "#FF7272",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.46 89.9151L1139.78 98.0132L1134.95 109.375L1122.66 108.3L1119.88 96.2725L1130.46 89.9151Z",
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-1500 opacity-0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M660.099 818.798L651.4 831.695L638.503 822.996L647.202 810.099L660.099 818.798Z",
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M577.311 262.954L583.669 247.219L599.403 253.576L593.046 269.311L577.311 262.954Z",
    fill: "#B35BF0",
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M698.544 264.851L689.312 266.645L684.753 258.42L691.167 251.542L699.69 255.516L698.544 264.851Z",
    fill: "#DB2FBD",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.38 159.25L1020.59 168.482L1011.25 169.628L1007.28 161.105L1014.16 154.691L1022.38 159.25Z",
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M657.967 314.92L675.013 321.808L668.126 338.854L651.08 331.967L657.967 314.92Z",
    fill: "#F00A29",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M625.876 566.288L632.465 583.451L615.301 590.04L608.712 572.876L625.876 566.288Z",
    fill: "#FF7272",
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.17 495.663L1176.58 491.838L1177.57 482.485L1186.77 480.53L1191.47 488.674L1185.17 495.663Z",
    fill: "#DB2FBD",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M924.06 18.3567L924.763 31.7734L911.346 32.4765L910.643 19.0599L924.06 18.3567Z",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M419.83 443.203L420.484 435.731L427.281 432.562L433.425 436.863L432.771 444.335L425.974 447.505L419.83 443.203Z",
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M724.118 391.495L731.506 400.951L727.011 412.078L715.128 413.748L707.74 404.292L712.235 393.165L724.118 391.495Z",
    fill: "#F00A29",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-100 opacity-0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M145.902 280.442L139.731 288.937L129.288 287.84L125.017 278.247L131.189 269.753L141.632 270.85L145.902 280.442Z",
    fill: "#DB2FBD",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-200 opacity-0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M288.749 795.043L282.529 812.133L270.839 798.202L288.749 795.043Z",
    fill: "#FF7272",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-300 opacity-0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M837.161 721.321L854.881 725.412L842.478 738.713L837.161 721.321Z",
    fill: "#DB2FBD",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-400 opacity-0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M597.007 390.996L589.366 398.908L578.692 396.247L575.66 385.673L583.302 377.76L593.975 380.422L597.007 390.996Z",
    fill: "#F00A29",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-500 opacity-0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M889.816 700.909L889.499 682.726L905.405 691.543L889.816 700.909Z",
    fill: "#DB2FBD",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153.664 382.871L147.646 388.484L140.449 384.494L142.019 376.416L150.187 375.413L153.664 382.871Z",
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M950.977 783.601L939.306 787.62L931.878 777.762L938.958 767.651L950.762 771.259L950.977 783.601Z",
    fill: "#FF7272",
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.153 368.375L92.9312 354.903L106.403 362.681L98.6252 376.153L85.153 368.375Z",
    fill: "#FF7272",
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M583.426 696.968L575.465 686.778L582.696 676.057L595.126 679.622L595.578 692.545L583.426 696.968Z",
    fill: "#DB2FBD",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M988.664 645.584L975.745 639.832L981.497 626.912L994.416 632.664L988.664 645.584Z",
    fill: "#FF7272",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M619.456 841.998L631.915 852.452L621.461 864.91L609.002 854.456L619.456 841.998Z",
    fill: "#FF7272",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M416.408 753.111L423.276 751.738L426.705 745.63L428.078 752.498L434.186 755.927L427.318 757.3L423.889 763.408L422.516 756.539L416.408 753.111Z",
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.6 51.5387L1182.28 44.0259L1174.72 42.9642L1181.46 39.3827L1180.13 31.8699L1185.62 37.1693L1192.36 33.5878L1189.01 40.4444L1194.5 45.7438L1186.95 44.6821L1183.6 51.5387Z",
    fill: "#DB2FBD",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M606.904 701.07L610.907 705.317L616.738 705.043L612.49 709.046L612.765 714.877L608.761 710.629L602.93 710.904L607.178 706.9L606.904 701.07Z",
    fill: "#DB2FBD",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-1500 opacity-0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M323.485 741.871L329.399 741.982L329.702 736.074L332.563 741.252L337.83 738.56L334.777 743.626L339.742 746.842L333.828 746.731L333.526 752.639L330.665 747.461L325.397 750.154L328.45 745.087L323.485 741.871Z",
    fill: "#B35BF0",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M374.202 651.901L372.818 643.453L365.503 639.004L373.951 637.62L378.4 630.305L379.784 638.754L387.099 643.202L378.651 644.587L374.202 651.901Z",
    fill: "#B35BF0",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M511.619 423.868L518.991 423.313L523.369 417.355L523.924 424.727L529.883 429.105L522.51 429.66L518.132 435.619L517.577 428.246L511.619 423.868Z",
    fill: "#DB2FBD",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M555.761 615.17L548.508 609.704L541.068 614.913L544.025 606.326L536.772 600.861L545.852 601.019L548.809 592.432L551.464 601.117L560.545 601.276L553.105 606.485L555.761 615.17Z",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.75 40.4952L1276.1 44.5446L1278.83 49.2637L1273.85 47.0473L1270.2 51.0968L1270.77 45.6776L1265.8 43.4612L1271.13 42.3283L1271.7 36.9091L1274.42 41.6281L1279.75 40.4952Z",
    fill: "#B35BF0",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M222.702 615.782L228.431 612.484L225.32 606.65L231.042 609.963L234.538 604.352L234.53 610.963L241.137 611.186L235.408 614.484L238.519 620.318L232.797 617.005L229.301 622.616L229.309 616.005L222.702 615.782Z",
    fill: "#F00A29",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.62 389.667L1268.47 395.118L1275.46 391.243L1272.08 398.486L1277.92 403.937L1269.99 402.963L1266.61 410.206L1265.09 402.361L1257.16 401.387L1264.15 397.512L1262.62 389.667Z",
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.18 360.66L1151.75 357.464L1148.77 350.793L1154.82 354.886L1159.11 348.969L1158.59 356.258L1165.86 357.013L1159.29 360.208L1162.27 366.88L1156.21 362.786L1151.93 368.703L1152.44 361.414L1145.18 360.66Z",
    fill: "#B35BF0",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M205.935 25.2376L212.124 24.5537L215.633 19.4106L216.317 25.5992L221.46 29.1084L215.272 29.7923L211.762 34.9354L211.078 28.7468L205.935 25.2376Z",
    fill: "#B35BF0",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M642.575 858.575L646.039 851.778L640.644 846.384L648.179 847.577L651.643 840.78L652.836 848.315L660.371 849.508L653.574 852.972L654.767 860.506L649.373 855.112L642.575 858.575Z",
    fill: "#F00A29",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-100 opacity-0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.54 369.612L1078.46 364.091L1077.47 356.764L1082.99 361.682L1090.32 360.692L1085.4 366.213L1086.39 373.54L1080.87 368.622L1073.54 369.612Z",
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-200 opacity-0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1512 668.514L19.044 663.17L13.8291 659.106L20.4033 659.806L21.3152 653.258L23.9966 659.301L30.1234 656.816L26.2307 662.16L31.4456 666.224L24.8714 665.525L23.9595 672.073L21.278 666.03L15.1512 668.514Z",
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-300 opacity-0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M113.54 752.549L118.102 753.771L120.674 749.81L120.921 754.526L125.483 755.749L121.074 757.441L121.321 762.157L118.349 758.487L113.94 760.179L116.512 756.219L113.54 752.549Z",
    fill: "#B35BF0",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-400 opacity-0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.78 461.761L1190.71 465.568L1196.81 464.306L1193 469.232L1194.26 475.329L1189.34 471.522L1183.24 472.784L1187.05 467.858L1185.78 461.761Z",
    fill: "#B35BF0",
    className: "animate-confetti-fall animation-delay-500 opacity-0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M515.381 134.868L520.993 131.372L517.68 125.65L523.513 128.761L526.812 123.032L527.034 129.639L533.645 129.631L528.034 133.127L531.347 138.849L525.514 135.738L522.215 141.467L521.993 134.86L515.381 134.868Z",
    fill: "#B35BF0",
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M334.192 770.808L342.608 775.096L349.287 768.417L347.809 777.746L356.225 782.034L346.896 783.511L345.418 792.84L341.13 784.424L331.802 785.902L338.48 779.223L334.192 770.808Z",
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M416.221 773.247L410.313 779.155L414.106 786.599L406.661 782.806L400.753 788.714L402.06 780.462L394.616 776.668L402.868 775.361L404.175 767.109L407.969 774.554L416.221 773.247Z",
    fill: "#FF7272",
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M309.485 541.885L314.251 544.527L318.236 540.811L317.196 546.159L321.962 548.801L316.554 549.465L315.514 554.814L313.211 549.876L307.803 550.54L311.788 546.824L309.485 541.885Z",
    fill: "#FF7272",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M625.517 440.641L622.599 449.624L630.24 455.176L620.795 455.176L617.876 464.158L614.957 455.176L605.512 455.176L613.153 449.624L610.235 440.641L617.876 446.193L625.517 440.641Z",
    fill: "#FF7272",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M888.671 687.829L881.897 682.595L873.514 684.33L878.748 677.555L877.013 669.172L883.788 674.407L892.171 672.671L886.936 679.446L888.671 687.829Z",
    fill: "#B35BF0",
    fillOpacity: 0.75,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M844.44 601.595L848.705 604.365L852.658 601.164L851.341 606.077L855.607 608.847L850.528 609.113L849.212 614.025L847.389 609.277L842.31 609.543L846.263 606.343L844.44 601.595Z",
    fill: "#F00A29",
    fillOpacity: 0.65,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M517.665 275.429L512.422 281.46L516.538 288.311L509.182 285.188L503.939 291.22L504.635 283.258L497.278 280.136L505.066 278.338L505.762 270.376L509.878 277.227L517.665 275.429Z",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.55 257.911L1174.5 249.062L1165.46 248.27L1173.24 243.593L1171.2 234.744L1178.05 240.702L1185.84 236.024L1182.29 244.384L1189.14 250.342L1180.1 249.551L1176.55 257.911Z",
    fill: "#B35BF0",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9587 289.664L25.913 284.316L20.7609 278.192L28.3693 280.675L31.0971 273.151L32.7512 280.981L40.631 279.581L34.6768 284.929L39.8288 291.053L32.2205 288.571L29.4927 296.095L27.8385 288.264L19.9587 289.664Z",
    fill: "#B35BF0",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1500 opacity-0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.57 667.665L1086.54 662.422L1079.69 666.538L1082.81 659.182L1076.78 653.939L1084.74 654.635L1087.86 647.278L1089.66 655.066L1097.62 655.762L1090.77 659.878L1092.57 667.665Z",
    fill: "#FF7272",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1400 opacity-0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M310.536 565.726L314.829 558.773L312.345 550.987L319.298 555.281L327.084 552.797L322.79 559.75L325.274 567.536L318.321 563.242L310.536 565.726Z",
    fill: "#B35BF0",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-1300 opacity-0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M323.635 249.557L313.561 250.493L307.714 258.749L306.778 248.675L298.521 242.828L308.596 241.892L314.443 233.635L315.379 243.71L323.635 249.557Z",
    fill: "#F00A29",
    fillOpacity: 0.85,
    className: "animate-confetti-fall animation-delay-1200 opacity-0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M369.383 363.91L364.262 362.046L360.907 366.34L361.097 360.895L355.977 359.031L361.215 357.529L361.405 352.083L364.452 356.601L369.69 355.099L366.335 359.393L369.383 363.91Z",
    fill: "#F00A29",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-1100 opacity-0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M504.472 600.392L510.036 600.593L510.417 595.039L513.025 599.958L518.026 597.511L515.07 602.228L519.689 605.336L514.125 605.135L513.744 610.689L511.136 605.77L506.135 608.217L509.092 603.499L504.472 600.392Z",
    fill: "#F00A29",
    fillOpacity: 0.35,
    className: "animate-confetti-fall animation-delay-1000 opacity-0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.41 503.283L1074.73 501.296L1071.39 505.134L1071.83 500.068L1067.15 498.08L1072.11 496.936L1072.55 491.87L1075.17 496.229L1080.12 495.085L1076.79 498.924L1079.41 503.283Z",
    fill: "#F00A29",
    fillOpacity: 0.9,
    className: "animate-confetti-fall animation-delay-900 opacity-0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M453.089 319.055L457.631 323.758L463.509 320.892L460.439 326.665L464.981 331.369L458.541 330.234L455.472 336.007L454.562 329.532L448.122 328.396L453.999 325.53L453.089 319.055Z",
    fill: "#FF7272",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-800 opacity-0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M267.127 394.943L271.684 387.945L264.838 383.164L273.177 383.611L273.894 375.291L277.676 382.737L285.24 379.198L280.683 386.196L287.53 390.978L279.191 390.53L278.474 398.85L274.692 391.405L267.127 394.943Z",
    fill: "#B35BF0",
    fillOpacity: 0.6,
    className: "animate-confetti-fall animation-delay-700 opacity-0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M394 570L392.428 565.163H387.343L391.457 562.174L389.886 557.337L394 560.326L398.114 557.337L396.543 562.174L400.657 565.163H395.572L394 570Z",
    fill: "#DB2FBD",
    fillOpacity: 0.45,
    className: "animate-confetti-fall animation-delay-600 opacity-0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicCelebrateConfetti);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_celebrate_confetti.c0d120da62ca8146a15e76ffd105d059.svg";